export const ACCESS_TOKEN_NAME = 'access_token'
export const ACCESS_TOKEN_EXPIRED = 'access_token_exp'
export const AUTHORITIES_NAME = 'authorities'
export const USER_NAME = 'userName'
export const USER_FULL_NAME = 'fullName'
export const USER_ID = 'userId'
export const RESET_PASSWORD_REQUIRED = 'reset_password_required'
export const REDIRECT_URI_NAME = 'redirect-uri'
export const TIME_OTP_EXPIRED = 'time_otp_exp'
export const CLIENT_ID_NAME = 'client-id'
export const APP_CODE_NAME = 'app-code'
export const SYSTEMS = 'systems'
export const PROVINCE_CODE = '003'
export const PROVINCE_NAME = 'Làng văn hóa'
export const CLIENT_ID = '53540a1899e369108fdebdd971df28060bb38071f44a5944cc095068497efcd7'
export const IS_VERIFY_OTP_WITH_MAIL = true

export const Authorities = {
  ROLE_ADMIN: 1,          
  ROLE_MANAGER: 2,      
  ROLE_USER: 3    
}

